import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const ModuleSubtopicDiskDrives = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Solid State Drives - Organization and Structure of Disk Drives"
      videos={[
        "https://www.youtube.com/embed/sveZw_GG_cs",
        "https://www.youtube.com/embed/dEt7mr9R_Z8"
      ]}
      takeaways={[
        { text: "Learn the diagram and theory related to disk drive organization." },
        { text: "Understand the significance of each part of a disk drive." },
        { text: "Sometimes, questions on disk scheduling algorithms can appear. Just have an overview." }
      ]}
      questions={[]} // No questions provided
      exampleVideos={[]} // No example videos provided
    />
);
}

export default ModuleSubtopicDiskDrives;
